// utils/employeeTransformers.ts

import { Nullable } from "../../../Types/Common";
import { EmployeeDetails } from "../../../Types/UserProfileDetails";

export const transformEmployeeDetails = (
  apiResponse: any
): Nullable<EmployeeDetails> => {
  const userProfileDetails = apiResponse?.data;
  if (!userProfileDetails) return null;
  const {
    attendance_data: attendanceData,
    education_info: educationInfo,
    finance_info: financialInfo,
    personal_info: personalInfo,
    work_info: workInfo,
    manager_details: managerDetails,
    additional_manager_details: additionalManagerDetails,
    edit_option: editOption,
    user_exit_info: userExitInfo,
    allowed_locations: allowedLocations,
    attendance_policy: attendancePolicy,
  } = userProfileDetails;

  return {
    jobInformation: {
      employeeCode: personalInfo?.emp_code ?? "",
      name: personalInfo?.name ?? "",
      email: personalInfo?.email ?? "",
      mobileNumber: personalInfo?.mobile_number ?? "",
      alternateMobileNumber: personalInfo?.alternet_no ?? "",
      department: personalInfo?.department ?? "",
      departmentId: personalInfo?.department_id ?? "",
      subDepartment: personalInfo?.sub_department ?? "",
      subDepartmentId: personalInfo?.sub_department_id ?? "",
      designation: personalInfo?.designation ?? "",
      centerId: Number(personalInfo?.center_id) ?? "",
      location: personalInfo?.center_name ?? "",
      doj: personalInfo?.doj ?? "",
      dob: personalInfo?.dob ?? "",
      userId: personalInfo?.user_id ?? "",
      profile: personalInfo?.profile ?? "",
      managerName: managerDetails
        ?.map(({ name }: { name: string }) => name)
        ?.join(","),
      managerEmail: managerDetails
        ?.map(({ email }: { email: string }) => email)
        ?.join(","),
      managerId: managerDetails?.map(({ id }: { id: string }) => id)?.join(","),
      additionalManagerNames: additionalManagerDetails
        ?.map(({ name }: { name: string }) => name)
        ?.join(","),
      additionalManagerEmails: additionalManagerDetails
        ?.map(({ email }: { email: string }) => email)
        ?.join(","),
      additionalManagerIds: additionalManagerDetails
        ?.map(({ id }: { id: string }) => id)
        ?.join(","),
      jobType: personalInfo?.job_type ?? "",
      probationDate: personalInfo?.probation_date,
      underProbhation: personalInfo?.under_probation,
      userType: personalInfo?.user_type,
      role: personalInfo?.role ?? 0,
      pettyCash: personalInfo?.petty_cash,
      jobTypeId: personalInfo?.job_type_id,
      attendancePolicyType: attendancePolicy?.name,
      attendancePolicyTypeId: attendancePolicy?.id,
    },
    employeeFamilyInformation: {
      fatherName: personalInfo?.father_name ?? "",
      fatherOccupation: personalInfo?.father_occupation ?? "",
      fatherContact: personalInfo?.father_contact ?? "",
      motherName: personalInfo?.mother_name ?? "",
      motherOccupation: personalInfo?.mother_occupation ?? "",
      motherContact: personalInfo?.mother_contact ?? "",
      maritalStatus: personalInfo?.maritalstatus ?? "",
      spouseName: personalInfo?.spouse_name ?? "",
      spouseOccupation: personalInfo?.spouse_occupation ?? "",
      spouseContact: personalInfo?.spouse_contact ?? "",
      userId: personalInfo?.user_id ?? "",
      anniversaryDate: personalInfo?.anniversary ?? "",
    },
    employeePersonalInformation: {
      gender: personalInfo?.gender ?? "",
      dob: personalInfo?.dob ?? null,
      contactNumber: personalInfo?.mobile_number ?? "",
      alternateContact: personalInfo?.alternet_no ?? "",
      alternateEmail: personalInfo?.alt_email ?? "",
      currentAddress: personalInfo?.ccity ?? "",
      permanentAddress: personalInfo?.pcity ?? "",
      currentState: personalInfo?.cstate ?? "",
      permanentState: personalInfo?.pstate ?? "",
      currentCity: personalInfo?.ccity ?? "",
      permanentCity: personalInfo?.pcity ?? "",
      currentPincode: personalInfo?.cpincode ?? "",
      permanentPincode: personalInfo?.ppincode ?? "",
      currentStreet: personalInfo?.cstreet ?? "",
      permanentStreet: personalInfo?.pstreet ?? "",
      userId: personalInfo?.user_id ?? "",
      status: personalInfo?.status ?? "",
      userType: personalInfo?.user_type,
      callingSystem: personalInfo?.calling_system,
      aadharCard: personalInfo?.aadhar_card ?? "",
      panCard: personalInfo?.pan_card ?? "",
      aadharCardNumber: personalInfo?.aadhar_number ?? "",
      panCardNumber: personalInfo?.pan_number ?? "",
    },
    employeeWorkInformation: workInfo,
    employeeEducationInformation:
      educationInfo?.length > 0
        ? educationInfo?.map(
            ({
              created_at,
              updated_at,
              ...rest
            }: {
              created_at: string;
              updated_at: string;
              addedby: string;
              strtyear: string;
              schoolname: string;
              education_id: string;
              endyear: string;
            }) => ({
              ...rest,
              addedBy: rest.addedby,
              start_year: rest.strtyear,
              school_name: rest.schoolname,
              course_id: rest.education_id,
              end_year: rest.endyear,
              institute_name: rest.schoolname,
            })
          )
        : [],
    employeeFinancialInformation: financialInfo.map((d: any) => ({
      ...d,
      aadharCard: personalInfo?.aadhar_card ?? "",
      panCard: personalInfo?.pan_card ?? "",
      aadharCardNumber: personalInfo?.aadhar_number ?? "",
      panCardNumber: personalInfo?.pan_number ?? "",
    })),
    attendanceData,
    editOption,
    managerDetails,
    additionalManagerDetails,
    user_exit_info: userExitInfo,
    allowedLocations,
    attendancePolicy,
  };
};
